import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, TemplateRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslatePipe } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { BaseListCombinedService } from '../../../../../@core/services/base-list-combined.service';
import { applySearchRule, removeRuleRecursive } from '../../../../../@core/utils/search-input-helper';
import { AddressPostalLink, Operator, SearchInput, SearchRule } from '../../../../../generated/generated-types';
import { BaseListWrapperComponent } from '../../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../../shared/components/new-base-list-component/new-base-list-component";
import { AddressPostalLinkService } from '../../../services/address-postal-link.service';
import { AddressPostalLinkEditWidgetComponent } from '../address-postal-link-edit-widget/address-postal-link-edit-widget.component';

@Component({
  selector: 'app-widget-address-postal-links-list',
  templateUrl: './widget-address-postal-links-list.component.html',
  providers: [AddressPostalLinkService],
  standalone: true,
  imports: [
    BaseListWrapperComponent,
    TranslatePipe,
    CommonModule,
    TooltipModule,
  ]
})
export class WidgetAddressPostalLinksListComponent extends NewBaseListComponent<AddressPostalLink> implements OnChanges {

  @Input()
  addressId: string;

  @Output()
  recordSelected = new EventEmitter<AddressPostalLink>();

  @Input()
  selectSingleItemMode = false;

  @ViewChild('iconTemplate')
  iconTemplate: TemplateRef<any>;
  // @Output()
  // recordSelected = new EventEmitter<AddressPostalLink>();

  constructor(
    private addressPostalLinkService: AddressPostalLinkService,
    private baseListServices: BaseListCombinedService) {

    super("AddressPostalLink", addressPostalLinkService);
    // this.applyClick = this.applyClick.bind(this);

    // this.data = resourceService;
    //this.allowClone = false;
    this.noCopy = true;
    this.dialogEditMode = true;
    this.inlineEditMode = false;
    this.addInDialog = true;
    this.addInDetail = false;
    // this.noBaseEdit = true;
    this.skipColsInFilter = 1;
  }

  async ngOnChanges(c) {
    if (c.addressId) {
      if (this.initialFetchExecuted)
        this.refresh();
    }
  }

  async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.addressPostalLinkService.subscribe(x => {
      if (x)
        this.cdRef.detectChanges();
    });
  }

  override getSearchInputForQuery(): SearchInput {
    let si = super.getSearchInputForQuery();

    let searchRule: SearchRule = {
      field: 'addressId',
      operator: Operator.equal,
      value: this.addressId
    };

    if (this.addressId) {
      applySearchRule(si, searchRule);
    } else removeRuleRecursive(searchRule, "addressId");

    return si;
  }

  saveInCRUDService(rowData: AddressPostalLink): Promise<AddressPostalLink> {
    // this.addressId is sometimes not set on exisiting, so then just keep existing addressId 
    // TODO find the reason and fix it
    rowData.addressId = this.addressId ? this.addressId : rowData.addressId;
    return this.addressPostalLinkService.saveItem(rowData);
  }


  showEditDialog(rowData?: any, index?: number) {

    let detailModel = rowData ?? this.lastSelectedItemSig();

    let modal$ = this.baseListServices.modalService.fromComponent(AddressPostalLinkEditWidgetComponent, {
      size: 'md',
      verticalAlign: 'top',
      closable: true,
      title: this.baseListServices.i18nService.translate(_("postal-address.edit")),
      locals: {
        detailModel: rowData,
        addressId: this.addressId ?? detailModel?.addressId ?? detailModel?.address?.id,
      }
    });

    modal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: AddressPostalLink) => {

      if (res) {
        let existing = this.itemsSig().find(x => x?.id == res?.id);
        if (!existing)
          this.setItems([...this.itemsSig(), res]);
        else {
          let i = this.itemsSig().indexOf(existing);
          this.itemsSig()[i] = res;
        }
        // refresh for changes in isDefault when there are two items with isDefault true
        //check itemsSig for isDefault true items
        if (this.itemsSig().filter(x => x.isDefault).length > 1)
          this.refresh();
        this.cdRef.detectChanges();
      }
    });
  }
}
